module.exports = __webpack_public_path__ + "img/xzy03.e44120ee.png";